import axios from 'axios';
import { getAuthHeaders } from './auth';

const API_BASE = '/api';

export interface FeedbackTotals {
  rating: number; // -1 down, +1 up
  count: number;
}

export interface FeedbackRecent {
  id: number;
  rating: number;
  query?: string | null;
  answer?: string | null;
  comment?: string | null;
  domain?: string | null;
  language?: string | null;
  intent?: string | null;
  created_at?: string | null;
}

export interface FeedbackSummary {
  window_days: number;
  totals: FeedbackTotals[];
  recent: FeedbackRecent[];
}

export const getFeedbackSummary = async (days = 14, limit = 10): Promise<FeedbackSummary> => {
  const res = await axios.get(`${API_BASE}/admin/feedback/summary`, {
    headers: getAuthHeaders(),
    params: { days, limit },
  });
  return res.data;
};
